import { render } from "./WorkspaceNavigation.vue?vue&type=template&id=7db2143b"
import script from "./WorkspaceNavigation.vue?vue&type=script&lang=js"
export * from "./WorkspaceNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__